/* Konfigurator-Logik (ausgelagert aus collection.json custom_liquid wegen 50-KB-Section-Limit).
   Liest #mcd-cfg-data (JSON: versions[].{name,img,images,url,price,finishes[].{name,price,tag,kind,available}})
   und schaltet Version (Modell) + Surface (Finish) + Galerie. defer -> laeuft nach DOM-Parse. */
(function () {
  var dataEl = document.getElementById('mcd-cfg-data');
  if (!dataEl) return;
  var versions;
  try { versions = JSON.parse(dataEl.textContent); } catch(e) { return; }
  if (!versions || !versions.length) return;

  var wingImg   = document.getElementById('mcd-cfg-wing-img');
  var thumbsEl  = document.getElementById('mcd-cfg-thumbs');
  var vNameEl   = document.getElementById('mcd-cfg-vname');
  var finishEl  = document.getElementById('mcd-cfg-finishes');
  var priceEl   = document.getElementById('mcd-cfg-price');
  var availEl   = document.getElementById('mcd-cfg-avail');
  var tagsEl    = document.getElementById('mcd-cfg-tags');
  var vbar      = document.getElementById('mcd-cfg-vbar');
  var tagsBase  = tagsEl ? (tagsEl.getAttribute('data-base') || tagsEl.value) : '';

  var activeVersion = 0;
  var activeFinish  = 0;

  function slugify(s) { return (s || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function updateTags() {
    if (!tagsEl) return;
    var ver = versions[activeVersion] || {};
    var f = (ver.finishes || [])[activeFinish] || {};
    var extra = [];
    if (ver.name) extra.push('version-' + slugify(ver.name));
    if (f && f.name) extra.push('finish-' + slugify(f.name));
    tagsEl.value = tagsBase + (extra.length ? ', ' + extra.join(', ') : '');
  }
  function setWingImg(src) {
    if (!wingImg || !src) return;
    if (/width=\d+/.test(src)) {
      wingImg.sizes = '(max-width: 768px) 92vw, 46vw';
      wingImg.srcset = [400, 600, 900, 1200].map(function (w) { return src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
      wingImg.src = src.replace(/width=\d+/, 'width=600');
    } else {
      wingImg.removeAttribute('srcset');
      wingImg.src = src;
    }
  }
  function setActiveThumb(btn) {
    if (!thumbsEl) return;
    Array.prototype.slice.call(thumbsEl.querySelectorAll('.mcd-cfg__thumb')).forEach(function (t) { t.classList.toggle('is-active', t === btn); });
  }
  function wireThumb(btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-img');
      if (src) { setWingImg(src); }
      setActiveThumb(btn);
    });
  }
  function buildThumbs(ver) {
    if (!thumbsEl) return;
    var imgs = ver.images || [];
    thumbsEl.innerHTML = '';
    thumbsEl.style.display = imgs.length > 1 ? '' : 'none';
    imgs.forEach(function (src, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mcd-cfg__thumb' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('data-img', src);
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      var im = document.createElement('img');
      im.src = (/width=\d+/.test(src) ? src.replace(/width=\d+/, 'width=160') : src);
      im.alt = ''; im.loading = 'lazy'; im.width = 160; im.height = 120; im.decoding = 'async';
      btn.appendChild(im);
      wireThumb(btn);
      thumbsEl.appendChild(btn);
    });
  }

  if (vbar && versions.length > 1) {
    vbar.removeAttribute('hidden');
  }

  function updateFinishes(ver) {
    if (!finishEl) return;
    finishEl.innerHTML = '';
    activeFinish = 0;
    var finishes = ver.finishes || [];
    finishes.forEach(function (f, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mcd-cfg__fpill' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      btn.dataset.price = f.price;
      btn.dataset.tag   = f.tag || '';
      btn.dataset.avail = f.available ? 'true' : 'false';
      var txt = document.createElement('span');
      txt.className = 'mcd-cfg__fpill-text';
      var nameSpan = document.createElement('span');
      nameSpan.className = 'mcd-cfg__fpill-name';
      nameSpan.textContent = f.name;
      txt.appendChild(nameSpan);
      if (f.tag) {
        var tagSpan = document.createElement('span');
        tagSpan.className = 'mcd-cfg__fpill-tag';
        tagSpan.textContent = f.tag;
        txt.appendChild(tagSpan);
      }
      btn.appendChild(txt);
      btn.addEventListener('click', function () { selectFinish(i); });
      finishEl.appendChild(btn);
    });
    updatePriceAvail(finishes[0] || {});
  }

  function selectFinish(idx) {
    activeFinish = idx;
    var pills = finishEl ? Array.prototype.slice.call(finishEl.querySelectorAll('.mcd-cfg__fpill')) : [];
    pills.forEach(function (p, i) {
      var on = (i === idx);
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var ver = versions[activeVersion] || {};
    var f = (ver.finishes || [])[idx] || {};
    updatePriceAvail(f);
    updateTags();
  }

  function updatePriceAvail(f) {
    if (priceEl) priceEl.textContent = f.price || '';
    if (availEl) availEl.textContent = f.available ? 'In stock' : 'Sold out';
  }

  function selectVersion(idx) {
    activeVersion = idx;
    var ver = versions[idx] || {};

    if (wingImg && ver.img) {
      wingImg.classList.add('is-loading');
      var newSrc = ver.img;
      var tmp = new Image();
      tmp.onload = function () {
        setWingImg(newSrc);
        wingImg.alt = (ver.name || '') + ' winglet';
        wingImg.classList.remove('is-loading');
      };
      tmp.onerror = function () { wingImg.classList.remove('is-loading'); };
      tmp.src = (/width=\d+/.test(newSrc) ? newSrc.replace(/width=\d+/, 'width=600') : newSrc);
    }

    if (vNameEl) vNameEl.textContent = ver.name || '';
    updateTags();
    buildThumbs(ver);

    if (vbar) {
      var vpills = Array.prototype.slice.call(vbar.querySelectorAll('.mcd-cfg__vpill'));
      vpills.forEach(function (p, i) {
        var on = (i === idx);
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    updateFinishes(ver);
  }

  if (vbar) {
    var vpills = Array.prototype.slice.call(vbar.querySelectorAll('.mcd-cfg__vpill'));
    vpills.forEach(function (btn, i) {
      btn.addEventListener('click', function () { selectVersion(i); });
    });
  }

  if (finishEl) {
    var existingFpills = Array.prototype.slice.call(finishEl.querySelectorAll('.mcd-cfg__fpill'));
    existingFpills.forEach(function (btn, i) {
      btn.addEventListener('click', function () { selectFinish(i); });
    });
  }

  // Initiale Tags setzen (Bild ist server-seitig schon responsive)
  updateTags();
  if (thumbsEl) {
    var initThumbs = Array.prototype.slice.call(thumbsEl.querySelectorAll('.mcd-cfg__thumb'));
    initThumbs.forEach(wireThumb);
    if (initThumbs.length <= 1) { thumbsEl.style.display = 'none'; }
  }

})();
